import {
  AI_CHATGPT,
  AI_GEMINI,
  AI_DEEPSEEK_ICON,
} from "@/components/atoms/IconSet";
import CONFIGS from "@/constants/env";
import type { TAIProvider, TAIModal } from "@/interfaces/type";
import dayjs from "dayjs";
import CryptoJS from "crypto-js";

const Utils = {
  encryptWithAES(_data: string, _key?: string) {
    const passphrase = _key || `${CONFIGS.KEYTEXT}`;
    // return crypto.AES.encrypt(JSON.stringify({ _data }), passphrase).toString();

    const encJson = CryptoJS.AES.encrypt(
      JSON.stringify(_data),
      passphrase,
    ).toString();
    const encData = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(encJson),
    );
    return encData;
  },
  /**
   * @description Function to decrypt data with AES
   * @param _cipherText - data to decrypt
   * @param _key - key to decrypt data
   * @returns string
   */
  decryptWithAES(_cipherText: string, _key?: string) {
    try {
      const passphrase = _key || `${CONFIGS.KEYTEXT}`;
      const decData = CryptoJS.enc.Base64.parse(_cipherText).toString(
        CryptoJS.enc.Utf8,
      );
      const bytes = CryptoJS.AES.decrypt(decData, passphrase).toString(
        CryptoJS.enc.Utf8,
      );
      return bytes;
    } catch {
      return null;
    }
  },
  getIconAIModelByAIModal: (ai_model: TAIModal) => {
    switch (ai_model) {
      case "gemini-1":
      case "gemini-1.5-pro":
      case "gemini-2.0-flash-exp":
      case "gemini-pro":
      case "gemini-advanced":
      case "gemini-ultra":
        return AI_GEMINI();
      case "deepseek-chat":
      case "deepseek-coder":
        return AI_DEEPSEEK_ICON();
      default:
        return AI_CHATGPT();
    }
  },

  /**
   * @description Function to remove dash or underscore from string
   * @param {string} str
   * @returns {string}
   * @example
   * removeDashOrUnderscore("hello-world") // hello world
   * removeDashOrUnderscore("hello_world") // hello world
   */
  removeDashOrUnderscore: (str: string): string => {
    return str.replace(/-|_/g, " ");
  },
  formattedDate(_date: string): string {
    // test
    // 7 ago -> 20 Aug 2024
    // 3 ago -> 24 Aug 2024, 12.00 PM
    // Yesterday, 15.00 PM
    // Today, 17.00 PM
    // More than year, show "{value} year ago"
    const _diffDate = dayjs().diff(_date, "day");
    if (_diffDate >= 365) {
      return `${Math.floor(_diffDate / 365)} ${
        Math.floor(_diffDate / 365) > 1 ? "years" : "year"
      } ago`;
    } else if (_diffDate >= 7 || _diffDate < 0) {
      return dayjs(_date).format("DD MMM YYYY");
    } else if (_diffDate >= 2) {
      return dayjs(_date).format("DD MMM YYYY, HH:mm A");
    } else if (_diffDate >= 1) {
      return `Yesterday, ${dayjs(_date).format("HH:mm A")}`;
    } else {
      return `Today, ${dayjs(_date).format("HH:mm A")}`;
    }
  },
  copyClipboard: (value: string) => navigator.clipboard.writeText(value),
  /**
   * @description Get Icon AI name includes
   * @param {string} name
   * @returns {JSX.Element}
   */
  getIconAIProviderByAIProvider: (ai_provider: TAIProvider): JSX.Element => {
    switch (ai_provider) {
      case "deepseek-chat":
        return AI_DEEPSEEK_ICON();
      case "gemini":
        return AI_GEMINI();
      default:
        return AI_CHATGPT();
    }
  },
};

export default Utils;
